import _ from 'lodash';

// The logic below has been taken as it is from the old app
const commonWords = {
  passing: ['Success', 'Successful', 'Pass'],
  failing: ['Failed', 'Failure', 'Fail'],
  warning: ['Warning', 'Warning', 'Warn'],
};

// Takes a subject sentence and replaces any common words with its associated category
// Ex: "Pass: This machine is a success" would become "Fail: This machine is a failure"
export const generateRuleValue = function (subject, category) {
  if (!_.isString(subject)) return subject;

  // Cycle through each common word list
  for (const categoryWords in commonWords) {
    // Cycle through each word in the list
    for (const word in commonWords[categoryWords]) {
      // If the subject contains a word in the list
      if (subject.includes(commonWords[categoryWords][word])) {
        // Replace it with the correct corresponding word from another list
        return subject.replace(commonWords[categoryWords][word], commonWords[category][word]);
      }
    }
  }
  return subject;
};
